import React from 'react';
import { motion } from 'framer-motion';
import {
    Construction,
    ArrowLeft,
    Sparkles,
    Compass
} from 'lucide-react';

export default function UnderConstruction() {
    // BRAND COLORS
    const darkGreen = "#1A2E20";
    const goldAccent = "#D4AF37";
    const creamBg = "#FDFBF7";
    const bgPattern = "https://www.transparenttextures.com/patterns/natural-paper.png";

    const fadeIn = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.8, ease: "easeOut" }
    };

    return (
        <div
            style={{ backgroundColor: creamBg, color: darkGreen }}
            className="min-h-screen font-sans selection:bg-[#D4AF37] selection:text-white relative flex items-center justify-center px-4 sm:px-6 overflow-hidden"
        >
            {/* Background Texture Overlay */}
            <div
                className="absolute inset-0 pointer-events-none opacity-40 z-10"
                style={{ backgroundImage: `url(${bgPattern})` }}
            ></div>

            {/* Glowing ambient background element */}
            <div
                className="absolute w-[300px] h-[300px] sm:w-[500px] sm:h-[500px] rounded-full blur-[120px] opacity-10 pointer-events-none z-0"
                style={{ backgroundColor: goldAccent }}
            ></div>

            <div className="relative z-20 max-w-2xl w-full text-center my-auto py-12">
                <motion.div
                    initial="initial"
                    animate="animate"
                    variants={fadeIn}
                    className="bg-white border border-[#E5E0D8] rounded-[2rem] sm:rounded-[3rem] p-8 sm:p-12 md:p-16 shadow-2xl relative overflow-hidden max-w-[350px] sm:max-w-xl md:max-w-full mx-auto w-full"
                >
                    {/* Inner Decorative Card Pattern */}
                    <div
                        className="absolute inset-0 opacity-5 pointer-events-none"
                        style={{ backgroundImage: `url(${bgPattern})` }}
                    ></div>

                    <div className="relative z-10 flex flex-col items-center">
                        {/* Animated Icon Container */}
                        <motion.div
                            animate={{ rotate: [0, -5, 5, -5, 0] }}
                            transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
                            className="h-14 w-14 sm:h-16 sm:w-16 rounded-full flex items-center justify-center mb-6 sm:mb-8 shadow-md"
                            style={{ backgroundColor: `${goldAccent}1A` }}
                        >
                            <Construction color={goldAccent} size={28} className="sm:w-8 sm:h-8" />
                        </motion.div>

                        <span
                            style={{ color: goldAccent }}
                            className="font-bold uppercase tracking-[0.3em] sm:tracking-[0.4em] text-[10px] sm:text-[11px] block mb-3 sm:mb-4 flex items-center gap-2"
                        >
                            <Sparkles size={12} /> A New Sanctuary Awaits
                        </span>

                        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl mb-4 sm:mb-6 leading-tight" style={{ color: darkGreen }}>
                            Under <br className="sm:hidden" />
                            <span className="italic font-light" style={{ color: goldAccent }}>Development</span>
                        </h1>

                        <div className="h-[1px] w-16 sm:w-20 my-2 sm:my-4" style={{ backgroundColor: `${darkGreen}20` }}></div>

                        <p className="text-gray-600 text-sm sm:text-base font-light max-w-md mx-auto mb-8 sm:mb-10 leading-relaxed">
                            We are carefully crafting and digitizing this space to preserve our collective traditions, knowledge, and healing practices. Thank you for your peaceful patience.
                        </p>

                        {/* Interactive Navigation Action */}
                        <button
                            onClick={() => window.history.back() || (window.location.href = "/")}
                            className="w-full sm:w-auto text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full font-bold uppercase text-[11px] sm:text-[12px] tracking-[0.2em] hover:opacity-90 transition-all flex items-center justify-center gap-3 group shadow-lg"
                            style={{ backgroundColor: darkGreen }}
                        >
                            <ArrowLeft size={14} className="group-hover:-translate-x-1 transition-transform" />
                            Go Back Home
                        </button>
                    </div>
                </motion.div>

                {/* Footer brand markup */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 0.5 }}
                    transition={{ delay: 0.5, duration: 1 }}
                    className="mt-8 flex items-center justify-center gap-2 text-[10px] uppercase tracking-[0.25em] font-medium"
                >
                    <Compass size={12} />
                    <span>Boseth Wellness Foundation</span>
                </motion.div>
            </div>
        </div>
    );
}